module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Gc-Ha-Ia.f1177e23.png";